import { createIcon } from '@chakra-ui/react'

const IconClock = createIcon({
  displayName: 'IconClock',
  viewBox: '0 0 16 16',
  path: (
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 1.5a6.5 6.5 0 100 13 6.5 6.5 0 000-13zM8 4v4l2.5 1.5"
    />
  )
})

export default IconClock
